import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { IDiscountPayload } from "../types/order";
import axiosSecondService, { AxiosSecondService } from "./axiosSecondService";
class DiscountService {
    readonly service: AxiosSecondService
    constructor() {
        this.service = axiosSecondService;
    }
    async calculateDiscount(payload: IDiscountPayload) {
        return this.service.post<any>(getPath(EP.AFFILIATE, EP.DROPSHIP, EP.CALCULATORDISCOUNT), payload)
    }
}
const discountService = new DiscountService();
export default discountService;